import { Pipe, PipeTransform } from '@angular/core'
import { ClinicService, FacilityService, Note } from '@mmx/shared'
import { TranslateService } from '@ngx-translate/core'
import moment from 'moment-timezone'

@Pipe({
  name: 'noteTooltip',
  standalone: false,
})
export class NoteTooltipPipe implements PipeTransform {
  constructor(
    private clinicService: ClinicService,
    private facilityService: FacilityService,
    private translateService: TranslateService,
  ) {}

  transform(note: Note): string {
    const facility = this.facilityService.current$.value
    const tz = facility?.timezone || this.clinicService.clinic?.settings?.defaultTimezone || 'America/New_York'
    const date = moment.tz(note.createdAt, tz).format('L LT')

    let text = `${this.translateService.instant('note.tooltip-prefix')} ${date}`

    if (note.clinician?.name) {
      text += ` ${this.translateService.instant('common.by')} ${note.clinician.name}`
    }

    if (note.appointment?.eid) {
      text += ` on ${note.appointment?.eid}`
    }

    return text
  }
}
